// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/load_events.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Load, LoadStatus } from "./load_pb.js";
import { file_trade_v1_load } from "./load_pb.js";
import type { LoadReconciliation } from "./load_reconciliation_pb.js";
import { file_trade_v1_load_reconciliation } from "./load_reconciliation_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/load_events.proto.
 */
export const file_trade_v1_load_events: GenFile = /*@__PURE__*/
  fileDesc("Chp0cmFkZS92MS9sb2FkX2V2ZW50cy5wcm90bxIIdHJhZGUudjEiqQIKCUxvYWRFdmVudBItCgdjcmVhdGVkGAEgASgLMhoudHJhZGUudjEuTG9hZENyZWF0ZWRFdmVudEgAEi0KB3VwZGF0ZWQYAiABKAsyGi50cmFkZS52MS5Mb2FkVXBkYXRlZEV2ZW50SAASLQoHZGVsZXRlZBgDIAEoCzIaLnRyYWRlLnYxLkxvYWREZWxldGVkRXZlbnRIABI6Cg5zdGF0dXNfY2hhbmdlZBgEIAEoCzIgLnRyYWRlLnYxLkxvYWRTdGF0dXNDaGFuZ2VkRXZlbnRIABJKChZyZWNvbmNpbGlhdGlvbl91cGRhdGVkGAUgASgLMigudHJhZGUudjEuTG9hZFJlY29uY2lsaWF0aW9uVXBkYXRlZEV2ZW50SABCBwoFZXZlbnQiMAoQTG9hZENyZWF0ZWRFdmVudBIcCgRsb2FkGAEgASgLMg4udHJhZGUudjEuTG9hZCJfChBMb2FkVXBkYXRlZEV2ZW50EiUKDXByZXZpb3VzX2xvYWQYASABKAsyDi50cmFkZS52MS5Mb2FkEiQKDHVwZGF0ZWRfbG9hZBgCIAEoCzIOLnRyYWRlLnYxLkxvYWQiMAoQTG9hZERlbGV0ZWRFdmVudBIcCgRsb2FkGAEgASgLMg4udHJhZGUudjEuTG9hZCKPAQoWTG9hZFN0YXR1c0NoYW5nZWRFdmVudBIcCgRsb2FkGAEgASgLMg4udHJhZGUudjEuTG9hZBItCg9wcmV2aW91c19zdGF0dXMYAiABKA4yFC50cmFkZS52MS5Mb2FkU3RhdHVzEigKCm5ld19zdGF0dXMYAyABKA4yFC50cmFkZS52MS5Mb2FkU3RhdHVzIrsBCh5Mb2FkUmVjb25jaWxpYXRpb25VcGRhdGVkRXZlbnQSHAoEbG9hZBgBIAEoCzIOLnRyYWRlLnYxLkxvYWQSPQoXcHJldmlvdXNfcmVjb25jaWxpYXRpb24YAiABKAsyHC50cmFkZS52MS5Mb2FkUmVjb25jaWxpYXRpb24SPAoWdXBkYXRlZF9yZWNvbmNpbGlhdGlvbhgDIAEoCzIcLnRyYWRlLnYxLkxvYWRSZWNvbmNpbGlhdGlvbkIvWi1wYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS10cmFkZS9hcGkvdjE7dHJhZGVfdjFiCGVkaXRpb25zcOgH", [file_trade_v1_load, file_trade_v1_load_reconciliation]);

/**
 * LoadEvent represents a load event
 *
 * @generated from message trade.v1.LoadEvent
 */
export type LoadEvent = Message<"trade.v1.LoadEvent"> & {
  /**
   * @generated from oneof trade.v1.LoadEvent.event
   */
  event: {
    /**
     * @generated from field: trade.v1.LoadCreatedEvent created = 1;
     */
    value: LoadCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: trade.v1.LoadUpdatedEvent updated = 2;
     */
    value: LoadUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: trade.v1.LoadDeletedEvent deleted = 3;
     */
    value: LoadDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: trade.v1.LoadStatusChangedEvent status_changed = 4;
     */
    value: LoadStatusChangedEvent;
    case: "statusChanged";
  } | {
    /**
     * @generated from field: trade.v1.LoadReconciliationUpdatedEvent reconciliation_updated = 5;
     */
    value: LoadReconciliationUpdatedEvent;
    case: "reconciliationUpdated";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message trade.v1.LoadEvent.
 * Use `create(LoadEventSchema)` to create a new message.
 */
export const LoadEventSchema: GenMessage<LoadEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_events, 0);

/**
 * LoadCreatedEvent is emitted when a load is created
 *
 * @generated from message trade.v1.LoadCreatedEvent
 */
export type LoadCreatedEvent = Message<"trade.v1.LoadCreatedEvent"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.LoadCreatedEvent.
 * Use `create(LoadCreatedEventSchema)` to create a new message.
 */
export const LoadCreatedEventSchema: GenMessage<LoadCreatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_events, 1);

/**
 * LoadUpdatedEvent is emitted when a load is updated
 *
 * @generated from message trade.v1.LoadUpdatedEvent
 */
export type LoadUpdatedEvent = Message<"trade.v1.LoadUpdatedEvent"> & {
  /**
   * @generated from field: trade.v1.Load previous_load = 1;
   */
  previousLoad?: Load;

  /**
   * @generated from field: trade.v1.Load updated_load = 2;
   */
  updatedLoad?: Load;
};

/**
 * Describes the message trade.v1.LoadUpdatedEvent.
 * Use `create(LoadUpdatedEventSchema)` to create a new message.
 */
export const LoadUpdatedEventSchema: GenMessage<LoadUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_events, 2);

/**
 * LoadDeletedEvent is emitted when a load is deleted
 *
 * @generated from message trade.v1.LoadDeletedEvent
 */
export type LoadDeletedEvent = Message<"trade.v1.LoadDeletedEvent"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;
};

/**
 * Describes the message trade.v1.LoadDeletedEvent.
 * Use `create(LoadDeletedEventSchema)` to create a new message.
 */
export const LoadDeletedEventSchema: GenMessage<LoadDeletedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_events, 3);

/**
 * LoadStatusChangedEvent is emitted when a load status changes
 *
 * @generated from message trade.v1.LoadStatusChangedEvent
 */
export type LoadStatusChangedEvent = Message<"trade.v1.LoadStatusChangedEvent"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;

  /**
   * @generated from field: trade.v1.LoadStatus previous_status = 2;
   */
  previousStatus: LoadStatus;

  /**
   * @generated from field: trade.v1.LoadStatus new_status = 3;
   */
  newStatus: LoadStatus;
};

/**
 * Describes the message trade.v1.LoadStatusChangedEvent.
 * Use `create(LoadStatusChangedEventSchema)` to create a new message.
 */
export const LoadStatusChangedEventSchema: GenMessage<LoadStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_events, 4);

/**
 * LoadReconciliationUpdatedEvent is emitted when load reconciliation data is updated
 * This event contains both previous and updated reconciliation states to allow
 * listeners to calculate deltas (e.g., for POLI received_quantity adjustments)
 *
 * @generated from message trade.v1.LoadReconciliationUpdatedEvent
 */
export type LoadReconciliationUpdatedEvent = Message<"trade.v1.LoadReconciliationUpdatedEvent"> & {
  /**
   * @generated from field: trade.v1.Load load = 1;
   */
  load?: Load;

  /**
   * @generated from field: trade.v1.LoadReconciliation previous_reconciliation = 2;
   */
  previousReconciliation?: LoadReconciliation;

  /**
   * @generated from field: trade.v1.LoadReconciliation updated_reconciliation = 3;
   */
  updatedReconciliation?: LoadReconciliation;
};

/**
 * Describes the message trade.v1.LoadReconciliationUpdatedEvent.
 * Use `create(LoadReconciliationUpdatedEventSchema)` to create a new message.
 */
export const LoadReconciliationUpdatedEventSchema: GenMessage<LoadReconciliationUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_events, 5);

